import { render } from "./DoctorWomanIcon.vue?vue&type=template&id=72792564&scoped=true"
import script from "./DoctorWomanIcon.vue?vue&type=script&lang=ts"
export * from "./DoctorWomanIcon.vue?vue&type=script&lang=ts"

import "./DoctorWomanIcon.vue?vue&type=style&index=0&id=72792564&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-72792564"

export default script